Ext.define('WindowGroupsAddEdit', {
    extend: 'Ext.ux.window.WindowExd',
    title: Lang.grupa.capitalise(),
    width: 350,
    height: 500,
    closable: false,
    collapsible: false,
    modal: true,
    resizable: false,
    layout: 'fit',
    initComponent: function () {
        this.cid = Ext.id();
        this.items = [{
            xtype: 'panel',
            layout: 'column',
            items: [{
                xtype: 'form',
                id: this.cid + 'formpanel',
                bodyStyle: 'padding:10px 10px 10px 10px',
                defaults: {
                    labelWidth: 120
                },
                items: [{
                    id: this.cid + "nazwa",
                    name: "nazwa",
                    xtype: 'textfieldexd',
                    fieldLabel: Lang.nazwa,
                    allowBlank: false,
                    blankText: Lang.pole_nie_moze_byc_puste
                }, {
                    id: this.cid + "nip",
                    name: "nip",
                    xtype: 'textfieldexd',
                    fieldLabel: Lang.nip,
                    allowBlank: true,
                    hidden: !Const.ENABLETYCHY || this.type != Const.GROUP_TYPE_POJAZD,
                    blankText: Lang.pole_nie_moze_byc_puste
                }, {
                    id: this.cid + "adres",
                    name: "adres",
                    xtype: 'textfieldexd',
                    fieldLabel: Lang.adres,
                    allowBlank: true,
                    hidden: !Const.ENABLETYCHY || this.type != Const.GROUP_TYPE_POJAZD,
                    blankText: Lang.pole_nie_moze_byc_puste
                }, {
                    id: this.cid + "eiid",
                    name: "eiid",
                    xtype: 'textfieldexd',
                    fieldLabel: Lang.eiid,
                    allowBlank: true,
                    hidden: (!Const.ENABLETYCHY && !Const.OPTIMALFLAG && !Const.PROFLAG && !Const.ULTIMATEFLAG && !Const.ENTERPRISEFLAG),
                    blankText: Lang.pole_nie_moze_byc_puste
                }, {
                    id: this.cid + "idplyntw",
                    name: "idplyntw",
                    fieldLabel: Lang.plyn,
                    allowBlank: !Const.ENABLETRAMWAJE,
                    xtype: "comboexd",
                    minChars: 1,
                    editable: true,
                    hidden: !Const.ENABLETRAMWAJE,
                    store: Ext.create('Ext.data.Store', {
                        fields: ['id', 'nazwa'],
                        proxy: {
                            type: 'ajax',
                            url: 'rest/plyny/getShortList',
                            actionMethods: {
                                read: 'POST'
                            },
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            paramsAsJson: true,
                            reader: {
                                type: 'json',
                                rootProperty: 'data'
                            }
                        },
                        autoLoad: true
                    }),
                    displayField: 'nazwa',
                    valueField: 'id',
                    forceSelection: true,
                    emptyText: '...'
                }, {
                    id: this.cid + "bakpojemnosc",
                    name: "bakpojemnosc",
                    xtype: 'numberfieldexd',
                    fieldLabel: Lang.bak_pojemnosc + Lang.jednostka_text,
                    allowBlank: !Const.ENABLETRAMWAJE,
                    decimalPrecision: 3,
                    blankText: Lang.pole_nie_moze_byc_puste,
                    hidden: !Const.ENABLETRAMWAJE,
                    minValue: Const.ENABLETRAMWAJE ? 0.001 : undefined,
                    maxValue: 9999999
                }, {
                    id: this.cid + "typtaboru",
                    name: "typtaboru",
                    xtype: 'textfieldexd',
                    fieldLabel: Lang.typ_taboru,
                    hidden: !Const.ENABLETRAMWAJE,
                    editable: true
                }, {
                    id: this.cid + "idgrupaoperator",
                    name: "idgrupaoperator",
                    xtype: 'comboexd',
                    fieldLabel: Lang.grupa_zarzadzajaca,
                    hidden: Const.BASICFLAG || Const.OPTIMALFLAG || Const.STANDARDFLAG,
                    allowBlank: true,
                    store: Ext.create('Ext.data.Store', {
                        fields: ['id', 'nazwa'],
                        proxy: {
                            type: 'ajax',
                            url: 'rest/grupyoperators/getList',
                            actionMethods: {
                                read: 'POST'
                            },
                            reader: {
                                type: 'json',
                                rootProperty: 'data'
                            }
                        },
                        listeners: {
                            load: function (store) {
                                store.insert(0, {id: 0, nazwa: Lang.brak});
                            }
                        },
                        autoLoad: true
                    }),
                    value: 0,
                    displayField: 'nazwa',
                    valueField: 'id',
                    typeAheadDelay: 200,
                    forceSelection: true,
                    queryMode: 'remote',
                    triggerAction: 'all'
                }, {
                    id: this.cid + "opis",
                    name: "opis",
                    xtype: 'textareaexd',
                    fieldLabel: Lang.opis,
                    allowBlank: true,
                    blankText: Lang.pole_nie_moze_byc_puste
                }]
            }]
        }];
        this.buttons = [{
            xtype: 'tbfill'
        }, {
            id: this.cid + 'save',
            text: Lang.zapisz,
            scope: this,
            handler: this.saveOp
        }, {
            id: this.cid + 'cancel',
            text: Lang.anuluj,
            scope: this,
            handler: this.closeOp
        }];
        if (this.type == Const.GROUP_TYPE_ODBIORCA) {
            this.title = Lang.grupa + ' (' + Lang.odbiorcy.capitalise() + ')';
        } else if (this.type == Const.GROUP_TYPE_POJAZD) {
            this.title = Lang.grupa + ' (' + Lang.pojazdy.capitalise() + ')';
        }
        this.callParent(arguments);
    },
    showW: function (obiektid) {
        if (!validPrivilegesOperatorComplex('access.manage.grupy')) {
            Ext.MessageBox.alert(Lang.error, Lang.brak_uprawnien_do_wykonania_operacji);
            return;
        }
        this.obiektid = obiektid;
        this.obiekt = null;
        sendAjaxDataJsonRpcL("rest/grupy/getObjectForEdit", {
            id: obiektid
        }, this, function (data) {
            if (data.status) {
                this.obiekt = data.data;
                this.show();
                this.center();
                this.setKeyMap({
                    'ESC': {
                        scope: this,
                        handler: this.closeOp
                    }
                });
                if (this.obiekt != null) {
                    Ext.getCmp(this.cid + "nazwa").setValue(this.obiekt.nazwa);
                    Ext.getCmp(this.cid + "nip").setValue(this.obiekt.nip);
                    Ext.getCmp(this.cid + "adres").setValue(this.obiekt.adres);
                    Ext.getCmp(this.cid + "eiid").setValue(this.obiekt.eiid);
                    Ext.getCmp(this.cid + "opis").setValue(this.obiekt.opis);
                    Ext.getCmp(this.cid + "idgrupaoperator").setValue(this.obiekt.idgrupaoperator);
                    Ext.getCmp(this.cid + "idplyntw").setValue(this.obiekt.idplyntw);
                    Ext.getCmp(this.cid + "bakpojemnosc").setValue(this.obiekt.bakpojemnosc);
                    Ext.getCmp(this.cid + "typtaboru").setValue(this.obiekt.typtaboru);
                }
            }
        });
    },
    saveOp: function () {
        if (!Ext.getCmp(this.cid + 'formpanel').form.isValid()) {
            Ext.MessageBox.alert(Lang.error, Lang.dane_niepoprawne);
            return;
        }

        if (Const.ENABLETRAMWAJE) {
            let newPlynValue = Ext.getCmp(this.cid + "idplyntw").getValue();
            let newBakPojemnoscValue = Ext.getCmp(this.cid + "bakpojemnosc").getValue();

            if (this.obiekt && this.obiekt.idplyntw != newPlynValue) {
                this.showConfirmationDialog(Lang.czy_napewno_zmienic_plyn, () => {
                    // this.handleBakPojemnoscChange(newBakPojemnoscValue, false);
                }, () => {
                    this.handleBakPojemnoscChange(newBakPojemnoscValue, true);
                });
            } else {
                this.handleBakPojemnoscChange(newBakPojemnoscValue, true);
            }
        } else {
            this.performSave();
        }
    },

    handleBakPojemnoscChange: function (newBakPojemnoscValue, proceedWithSave) {
        if (this.obiekt && this.obiekt.bakpojemnosc != newBakPojemnoscValue) {
            this.showConfirmationDialog(Lang.czy_napewno_zmienic_pojemnosc_baku, () => {
            }, () => {
                if (proceedWithSave) {
                    this.performSave();
                }
            });
        } else {
            if (proceedWithSave) {
                this.performSave();
            }
        }
    },

    showConfirmationDialog: function (message, noCallback, yesCallback) {
        Ext.MessageBox.show({
            title: Lang.usuwanie,
            message: message,
            buttons: Ext.MessageBox.YESNO,
            scope: this,
            fn: function (btn) {
                if (btn == "no") {
                    noCallback.call(this);
                }
                if (btn == "yes") {
                    yesCallback.call(this);
                }
            }
        });
    },

    performSave: function () {
        sendAjaxDataJsonRpcL("rest/grupy/saveObject", {
            id: this.obiektid,
            nazwa: Ext.getCmp(this.cid + "nazwa").getValue(),
            adres: Ext.getCmp(this.cid + "adres").getValue(),
            eiid: Ext.getCmp(this.cid + "eiid").getValue(),
            nip: Ext.getCmp(this.cid + "nip").getValue(),
            opis: Ext.getCmp(this.cid + "opis").getValue(),
            idgrupaoperator: Ext.getCmp(this.cid + "idgrupaoperator").getValue(),
            optlockversion: this.obiekt ? this.obiekt.optlockversion : null,
            idplyntw: Ext.getCmp(this.cid + "idplyntw").getValue(),
            bakpojemnosc: Ext.getCmp(this.cid + "bakpojemnosc").getValue(),
            typtaboru: Ext.getCmp(this.cid + "typtaboru").getValue(),
            type: this.type
        }, this, function (data) {
            if (data.status) {
                var data = data.data;
                this.fireEvent("wclose");
                this.closeOp();
            } else {
                Ext.MessageBox.alert(Lang.error, data.error);
            }
        });
    },
    closeOp: function () {
        this.close();
    }
});

